<template>
    <BaseElement v-model="value" :edit="edit" :create="create" :element="'input'">
        <template #main="{text}">
            <template v-if="edit">
                <template v-if="value.calculate">
                    <Paragraph v-model="value" :edit="edit" :create="create"/>
                </template>
                <template v-else-if="value.type == 'checkbox'">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <input
                            :id="value.id"
                            :class="value.class"
                            :style="value.style"
                            :disabled="value.disabled"
                            :type="value.type"
                            :min="value.min"
                            :max="value.max"
                            v-model="value.value"
                            :defaultValue="value.value"
                            :placeholder="value.placeholder"
                        >
                        <span class="ms-1">
                            <span v-if="value.value">{{ $t("utils.true") }}</span>
                            <span v-else>{{ $t("utils.false") }}</span>
                        </span>
                    </div>
                </template>
                <template v-else>
                    <input
                        :id="value.id"
                        :class="value.class"
                        :style="value.style"
                        :disabled="value.disabled"
                        :type="value.type"
                        v-model="value.value"
                        :min="value.min"
                        :max="value.max"
                        :defaultValue="value.value"
                        :placeholder="value.placeholder"
                    >
                    <span v-if="value.units" class="ms-1">{{ value.units }}</span>
                </template>
            </template>
            <template v-else>
                <input
                    :id="value.id"
                    :class="value.class"
                    :style="value.style"
                    :type="value.type"
                    :disabled="true"
                    v-model="value.value"
                    :defaultValue="value.value"
                    :placeholder="value.placeholder"
                >
            </template>
        </template>
    </BaseElement>
</template>

<script>
import BaseElement from '@/components/calculations/BaseElement.vue';
import Paragraph from '@/components/calculations/Paragraph.vue';

export default {
    components: {
        BaseElement,
        Paragraph
    },
    props: {
        modelValue: {},
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        create: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        show: function () {
            return this.value && !this.value.hide;
        }
    }
}
</script>

<style lang="scss">
</style>